import React from 'react'
import { Alert, Button, Modal } from 'react-bootstrap'
import { useTheme } from '../../context/ThemeContext'

type Props = {
    showModal: boolean
    closeModal: () => void
    envelope: any
    onResendHandler: () => void
    message: string
    errorMessage: string
    loading: boolean
}

const ResendEnvelopeModal: React.FC<Props> = ({
    showModal,
    closeModal,
    envelope,
    onResendHandler,
    message, loading, errorMessage
}: Props) => {
    const { theme } = useTheme()
    return (
        <Modal
            contentClassName={`${theme === 'dark' ? 'theme__div' : ''}`}
            show={showModal}
            onHide={closeModal}
        >
            <Modal.Header>
                <Modal.Title
                    className={`text-truncate ${theme === 'dark' ? 'theme__div' : ''}`}
                >{`Resend "${envelope?.documentName?.trim()}"`}</Modal.Title>
                <i className={`bi bi-x-lg modal-icon-custom ${theme === 'dark' && 'close'}`} onClick={closeModal}></i>

            </Modal.Header>
            <Modal.Body>

                <span className={theme === 'dark' ? 'white__text' : ''}>
                    Envelope will be resent to:
                    <ul className='my-2 text-italic'>
                        {envelope && envelope?.signerEmails?.map((email: any, index: any) => (
                            <li key={index}>{email}</li>
                        ))}
                    </ul>
                </span>
                {message && (
                    <Alert variant='success' className='mb-0 my-3 w-100'>
                        {message}!
                    </Alert>
                )}
                {errorMessage && (
                    <Alert variant='danger' className='mb-0 my-3 w-100'>
                        {errorMessage}!
                    </Alert>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant='secondary' onClick={closeModal}>
                    No
                </Button>
                <Button variant='primary' disabled={loading} onClick={onResendHandler}>
                    Yes
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ResendEnvelopeModal
